import axios from "axios";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../../components/layout/Layout";

export default function DeliveryCharges() {
  const [formData, setFormData] = useState({
    standardCharge: 0,
    emergencyCharge: 0,
    gst : 0,
  });
  const [disableBtn, setDisableBtn] = useState(false);

  useEffect(() => {
    getDevliveryCharges();
  }, []);

  const handleInputChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    if (name === "image") {
      setFormData({ ...formData, image: e.target.files[0] });
      return;
    }

    setFormData({ ...formData, [name]: value });
  };

  const getDevliveryCharges = async () => {
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/delivery-charge/get-delivery-charge`,
        { headers }
      );

      if (response.data.statusCode === 200) {
        console.log("response.data.result.deliveryCharge",response.data.result.deliveryCharge)
        setFormData(response.data.result.deliveryCharge);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisableBtn(true);
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      console.log("FormData Chan=rges",formData);
      const formdata = new FormData();
      formdata.append("standardCharge", formData.standardCharge);
      formdata.append("emergencyCharge", formData.emergencyCharge);
      formdata.append("gst", formData.gst);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/delivery-charge/save`,
        formdata,
        { headers }
      );
      if (response.data.statusCode === 200) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to edit charges. Please try again.", error);
    }
    setDisableBtn(false);
  };

  return (
    <>
      <Layout>
        <ToastContainer />
        <div>
          <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8 tracking-wide">
            {/* Header */}
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-medium">Update Delivery Charges</h2>
            </div>
            <div className="mt-10" onSubmit={handleSubmit}>
              <form action="">
                <div className="">
                  <label htmlFor="" className="text-sm">
                    Standard Charge
                  </label>{" "}
                  <br />
                  <input
                    type="number"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Enter Standard Charge"
                    name="standardCharge"
                    value={formData.standardCharge}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-3">
                  <label htmlFor="" className="text-sm">
                    Emergency Charge
                  </label>{" "}
                  <br />
                  <input
                    type="number"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Enter Emergency Charge"
                    name="emergencyCharge"
                    value={formData.emergencyCharge}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="mt-3">
                  <label htmlFor="" className="text-sm">
                    GST (in %)
                  </label>{" "}
                  <br />
                  <input
                    type="number"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Enter GST Percentage"
                    name="gst"
                    value={formData.gst}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="mt-8 text-end">
                  <button
                    type="submit"
                    className="bg-[#2c2c38] text-white h-[40px] px-8 rounded-md text-sm hover:bg-[#191919]"
                    disabled={disableBtn}
                  >
                    <i className="fa fa-plus"></i>{" "}
                    {disableBtn ? "Updating ..." : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}
